import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordTable from 'views/financial/depositRequests/recordTable'; // Importing RecordTable component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a record view.
 * @extends JetView
 */
export default class recordView extends JetView {
    /**
     * Configures the layout of the record view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerAA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching
                },
            ],
        };

        // Left side layout configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply the current theme
                    elements: [{ view: 'label', label: _('Historial') }], // Label with localized text
                },
                RecordTable, // Including the RecordTable component
                toolbar, // Including the toolbar
            ],
        };

        // Return the main layout configuration
        return {
            height: screen.width < 500 ? 500 : 0, // Conditional height based on screen width
            type: 'wide', // Layout type
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
